import React, { Component } from 'react';

import Core from './../../../Core/Core'

import Header from './../../Header';
import ClientForm from './../../Client/ClientForm';
import ErrorManager from '../../../Core/ErrorManager';
import ErrorBoundary from '../ErrorBoundary';

class ClientEdit extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            "client" : {},
            "initialAddress" : null
        };

        this.submit = this.submit.bind(this);
        this.handleRedux = this.handleRedux.bind(this);

        this.load(props.match.params.id);
    }
    load(id)
    {
        Core.Instance.Request(Core.Address+"Client/"+id, null, "GET")
        .then((data) => {
            data = data != null ? data : {};
            this.setState({
                "client" : data, 
                "initialAddress" : data.address
            });
        });
    }

    handleRedux(event)
    {
        let client = this.state.client;
        client[event.target.name] = event.target.value;
        this.setState({
            "client" : client
        });
    }

    submit()
    {
        if(!Core.Instance.CheckForm(this))
            return;
        let client = this.state.client;
        if(client.address != this.state.initialAddress)
        {
            client.latitude = null;
            client.longitude = null; //  Remise à zéro de la géolocalisation si changement addresse
        }


        let request = null;
        if(client.id == null)
            request = Core.Instance.Request(Core.Address+"Client", client, "POST");
        else 
            request = Core.Instance.Request(Core.Address+"Client/"+client.id, client, "PUT");
        request.then((json) => {
            return Core.Instance.user.RegisterEdit(this.state.client.id, "Edition des informations de base client.");
        }).then(() => {
            //ErrorManager.Instance.Info("Les modifications ont bien été enregistrées.");
            Core.Instance.GoBackWithRefresh();
        });      
    }

    render()
    {
        document.title = "W-F: Edition "+this.state.client.name;

        return (
            <ErrorBoundary>
                <Header buttons={ [
                    <button className="btn btn-primary" onClick={ this.submit }><li className="fas fa-save"> </li> Enregistrer</button>
                ] } />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            <div className="box m-3 p-3">
                                <h4>
                                    <li className="fas fa-user"> </li> Création/Edition des informations de base d'un client
                                </h4>
                                <hr />
                                <ClientForm client={ this.state.client } onChange={ this.handleRedux } />
                            </div>
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        );
    }
}
export default ClientEdit;



// WEBPACK FOOTER //
// ./src/Components/Views/Client/ClientEdit.js